module.exports = __webpack_public_path__ + "static/pocket_money_determine_bg-dce49e125a067b7f41a43e26df508020.svg";